import { render } from "./ProfileFormPrice.vue?vue&type=template&id=295c9860&scoped=true"
import script from "./ProfileFormPrice.vue?vue&type=script&lang=js"
export * from "./ProfileFormPrice.vue?vue&type=script&lang=js"

import "./ProfileFormPrice.vue?vue&type=style&index=0&id=295c9860&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-295c9860"]])

export default __exports__